import {
  Fragment,
  memo,
  useCallback,
  useEffect,
  useMemo,
  useState,
} from 'react';
import { CSSTransition } from 'react-transition-group';

import {
  BlockIcon,
  LegalPersonIcon,
  RestritoIcon,
  ViewIcon,
} from 'components/Icons';
import AnexoIcon from 'components/Icons/AnexoIcon';
import ComissaoEleitoralModal, {
  ComissaoEleitoralProps,
} from 'components/Modal/__LEGACY__/ComissaoEleitoralModal';
import PautaEleicaoModal, {
  IPautaEleicaoGenericProps,
} from 'components/Modal/__LEGACY__/PautaEleicaoModal/PautaEleicaoModal';
import AssembleiaPautaAssociadoActionButtons from 'components/__SHARED__/AssembleiaPautas/AssembleiaPautaAssociadoActionButtons';
import CountdownTimer from 'components/__SHARED__/CountdownTimer/CountdownTimer';
import {
  AssembleiaPautaStatus,
  AssembleiaTipoPauta,
  TipoVotoPauta,
} from 'helpers/enums/AssembleiaPautaStatus';
import { AssembleiaStatus } from 'helpers/enums/AssembleiaStatus';
import { AssembleiaTipo } from 'helpers/enums/AssembleiaTipo';
import { clsx } from 'helpers/utils/HTMLUtils';
import { getUniqueKey } from 'helpers/utils/KeyUtils';
import { pautaUtilsGetVotoByIdPauta } from 'helpers/utils/PautaUtils';
import {
  AssembleiaAssessorRoutePath,
  VotoPresencialPath,
} from 'library/Routes';
import {
  AgencyIcon,
  AssembleiasIcon,
  Button,
  ButtonThemes,
  CheckCircleIcon,
  ChevronArrowDownIcon,
  CloseIcon,
  Col,
  Collapse,
  ComunidadeIcon,
  IconButton,
  LockIcon,
  RadioButton,
  RadioButtonType,
  Row,
  TimesCircleIcon,
} from 'plataforma-fundacao-componentes';
import { useDispatch, useSelector } from 'react-redux';
import { useRouteMatch } from 'react-router-dom';
import { IAssembleiasAssessorItens } from 'store/modules/AssembleiasAssessorReducer';
import { assembleiaAssociadoActionsRefresh } from 'store/modules/AssembleiasAssociadoActions';
import {
  IAssembleiaAssociadoPauta,
  IAssembleiaAssociadoPautaOpcao,
  IAssembleiaAssociadoPautaVoto,
} from 'store/modules/AssembleiasAssociadoReducer';
import { modalsActionsOpen } from 'store/modules/ModalsActions';
import { IWSAssembleia } from 'store/modules/WSAssembleiasReducer';
import { IReducer } from 'store/Reducer';
import './AssembleiaPauta.scss';
import {
  getStatusClassName,
  getStatusName,
  PautaStatusType,
  STATUS_PAUTA_BLOQUEADA,
  STATUS_PAUTA_ENCERRADA,
  STATUS_PAUTA_LIBERADA,
} from './Pautas';
import styles from './styles.module.scss';

interface AssembleiaPautaNewProps {
  opened: boolean;
  toggleOpened: (evt: any) => void;
  titulo: string;
  descricao?: string;
  status: PautaStatusType;
  // callBackZerouTempo?: () => void;
  tempo?: number;
  // NEWS
  hasAnexos: boolean;
  onClickAnexos?: () => void;
  canParticipate?: boolean;
  pauta: IAssembleiaAssociadoPauta;
  loadingPautas?: boolean;
  bloqAlteraVoto?: boolean;
  blockedUntilQuorum?: boolean;
  cpfEfetivacaoPresencial?: string;
  updateVotoPresencial?: (
    idPauta: number,
    voto: IAssembleiaAssociadoPautaVoto[]
  ) => void;
  isColaborador?: boolean;
  canSeeResults?: boolean;
  idEventoParaEfetivacao?: string;
  agency?: string;
  nucleou?: string;
  sort?: (opened: boolean) => void;
}

export const PautaVotoInvalido: number = -1;

let timeoutFecharSucesso: any = null;
function AssembleiaPautaNew(props: AssembleiaPautaNewProps) {
  const [mostrarVotoEnviado, setMostrarVotoEnviado] = useState(false);
  const [voto, setVoto] = useState<number | null>(null);
  const [votoAtual, setVotoAtual] = useState<number | null>(null);

  const idItemPauta = props.pauta.votos?.length
    ? props.pauta.votos[0].idItemPauta
    : null;

  useEffect(() => {
    setVoto(idItemPauta);
    setVotoAtual(idItemPauta);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [JSON.stringify(props.pauta.votos || [])]);

  const handleToggle = () => {
    if (typeof props.toggleOpened === 'function') {
      props.toggleOpened(!props.opened);

      if (props.status === AssembleiaStatus.Live) {
        if (!props.pauta.votos.length) {
          setVotoAtual(null);
        } else {
          setVotoAtual(idItemPauta);
        }
      }
    }
  };

  const getStatusIcon = () => {
    switch (
      Boolean(isEfetivacaoVoto) ? AssembleiaPautaStatus.Liberada : props.status
    ) {
      case STATUS_PAUTA_LIBERADA:
        return <CheckCircleIcon />;
      case STATUS_PAUTA_ENCERRADA:
        return <TimesCircleIcon />;
      case STATUS_PAUTA_BLOQUEADA:
        return <LockIcon />;
      default:
        return '-';
    }
  };

  const getItemPautaName = (it: any) => {
    if (!it) return '';
    return it.flgAbstencao ? 'Me abstenho' : it.descricao;
  };

  // NEW RULES

  const isEfetivacaoVoto = useRouteMatch(VotoPresencialPath);
  const isAssessorRoute = useRouteMatch(AssembleiaAssessorRoutePath);

  const { auth, assembleias, assembleiasAssessor } = useSelector(
    (state: IReducer) => state
  );

  const [votoRegistrado, setRegistro] = useState<boolean>(
    props.pauta.votos && props.pauta.votos.length > 0
  );

  const currentEvent = useSelector(
    (state: IReducer) => state.assembleias.currentEvent
  );

  const [sessionIdItemPauta, setSessionIdItemPauta] = useState<number>();

  const initSessionVoto = useCallback(() => {
    const sessionVoto = pautaUtilsGetVotoByIdPauta(
      auth.usuario!.cpfCnpj,
      props.pauta.idPauta
    );
    if (sessionVoto) {
      setSessionIdItemPauta(sessionVoto.idItemPauta);
    }
  }, [props.pauta, auth]);

  useEffect(() => {
    initSessionVoto();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleVotoSuccess = (idItemPauta: number) => {
    setRegistro(true);
    setSessionIdItemPauta(idItemPauta);
  };

  const [loading, setLoading] = useState(false);

  const currentIdEvento = useMemo(() => {
    if (Boolean(isAssessorRoute)) {
      return assembleiasAssessor!?.evento!?.id!;
    }
    if (Boolean(isEfetivacaoVoto) && props.idEventoParaEfetivacao) {
      return props.idEventoParaEfetivacao;
    }
    return assembleias!?.currentEvent!?.id!;
  }, [
    isAssessorRoute,
    assembleiasAssessor,
    assembleias,
    isEfetivacaoVoto,
    props.idEventoParaEfetivacao,
  ]);

  const getVotoAtual = useCallback((): number => {
    if (sessionIdItemPauta !== undefined) return sessionIdItemPauta;
    if (props.pauta.votos && props.pauta.votos.length) {
      return props.pauta.votos[0].idItemPauta;
    }
    return PautaVotoInvalido;
  }, [props.pauta.votos, sessionIdItemPauta]);

  const isAGO = useMemo(() => {
    if (!currentEvent) return false;
    return (
      currentEvent.tipo !== AssembleiaTipo.Nucleo &&
      currentEvent.tipo !== AssembleiaTipo.Reuniao
    );
  }, [currentEvent]);

  const permiteVoto = useMemo(() => {
    return (
      props.pauta.estaVotadoPorOutroRepresentante && !props.pauta.podeVotar
    );
  }, [props.pauta.estaVotadoPorOutroRepresentante, props.pauta.podeVotar]);

  const tipoVotoPodeVotar = useMemo(() => {
    return [
      TipoVotoPauta.Vota,
      TipoVotoPauta.VotaNaoColaborador,
      TipoVotoPauta.VotaNaoRestrito,
    ].includes(props.pauta.tipoVotoPauta);
  }, [props.pauta]);

  const canVote = useMemo(() => {
    if (
      Boolean(isEfetivacaoVoto) &&
      auth.usuario!.perfil.assessorRoute.assembleias.pautas.incluirVotoManual &&
      tipoVotoPodeVotar
    ) {
      return true;
    }

    if (
      props.canParticipate &&
      auth.usuario!.perfil.associadoRoute.assembleias.pautas.participar &&
      tipoVotoPodeVotar
    ) {
      return true;
    }

    return false;
  }, [auth, isEfetivacaoVoto, props.canParticipate, tipoVotoPodeVotar]);

  const opcoesDisabled = useMemo(() => {
    if (votoRegistrado && assembleias.currentEvent?.bloqAlteraVoto) {
      return true;
    }
    if (
      loading ||
      props.loadingPautas ||
      props.pauta.status !== AssembleiaPautaStatus.Liberada
    ) {
      return true;
    }
    return false;
  }, [
    loading,
    props.loadingPautas,
    assembleias,
    votoRegistrado,
    props.pauta.status,
  ]);

  const getBarLabel = useMemo(() => {
    if (
      Boolean(isEfetivacaoVoto)
        ? props.pauta.status === AssembleiaPautaStatus.Liberada
        : props.pauta.status === AssembleiaPautaStatus.Liberada
    ) {
      if (
        props.pauta.votos.length < 1 &&
        props.pauta.itens.length !== 0 &&
        canVote &&
        !props.pauta.estaVotadoPorOutroRepresentante
      ) {
        return {
          icon: <ViewIcon />,
          label: 'Votar nesta pauta',
        };
      } else if (
        props.pauta.votos.length > 0 &&
        props.pauta.itens.length !== 0 &&
        props.bloqAlteraVoto
      ) {
        return {
          icon: <AssembleiasIcon />,
          label: 'Voto enviado',
        };
      } else if (
        currentEvent!?.userCanVote! &&
        !props.pauta.estaVotadoPorOutroRepresentante &&
        !props.bloqAlteraVoto
      ) {
        return {
          icon: <AssembleiasIcon />,
          label: 'Alterar voto',
        };
      } else {
        return {
          icon: <ViewIcon />,
          label: 'Visualizar pauta',
        };
      }
    } else if (
      !canVote ||
      props.pauta.estaVotadoPorOutroRepresentante ||
      (props.pauta.status === AssembleiaPautaStatus.Bloqueada &&
        props.pauta.itens.length !== 0)
    ) {
      return {
        icon: <ViewIcon />,
        label: 'Visualizar pauta',
      };
    } else {
      return {
        icon: <ViewIcon />,
        label: 'Visualizar pauta',
      };
    }
  }, [
    isEfetivacaoVoto,
    props.pauta.status,
    props.pauta.estaVotadoPorOutroRepresentante,
    props.pauta.itens.length,
    props.pauta.votos.length,
    props.bloqAlteraVoto,
    canVote,
    currentEvent,
  ]);

  const onVotoError = useCallback(() => {
    setVoto(getVotoAtual() || PautaVotoInvalido);
  }, [setVoto, getVotoAtual]);

  const dispatchAction = useDispatch();

  const openModalDetalhesChapa = useCallback(
    (item: any) => {
      const modalKey: string = getUniqueKey();
      dispatchAction(
        modalsActionsOpen(
          PautaEleicaoModal,
          {
            genericProps: {
              key: modalKey,
              item: item,
            } as IPautaEleicaoGenericProps,
          },
          modalKey
        )
      );
    },
    [dispatchAction]
  );

  const openModalComissaoEleitoral = useCallback(() => {
    const modalKey: string = getUniqueKey();
    dispatchAction(
      modalsActionsOpen(
        ComissaoEleitoralModal,
        {
          genericProps: {
            key: modalKey,
            idEvento:
              typeof currentIdEvento === 'string'
                ? parseInt(currentIdEvento)
                : currentIdEvento,
            isAssessor: Boolean(isAssessorRoute) || Boolean(isEfetivacaoVoto),
          } as ComissaoEleitoralProps,
        },
        modalKey
      )
    );
  }, [dispatchAction, isAssessorRoute, currentIdEvento, isEfetivacaoVoto]);

  const onCompletedContdown = useCallback(() => {
    props.toggleOpened(false);
    const idForCountdown = currentIdEvento;
    const assembleiaRefreshed = {
      id: idForCountdown,
      pautas: [
        {
          idPauta: props.pauta.idPauta,
          status: AssembleiaPautaStatus.Encerrada,
          tempoVotacao: 0,
          tempoRestante: 0,
        },
      ],
    };
    dispatchAction(
      assembleiaAssociadoActionsRefresh(assembleiaRefreshed as IWSAssembleia)
    );
  }, [props, currentIdEvento, dispatchAction]);

  const sortOptions = useCallback(
    (
      opA: {
        idItemPauta: number;
        descricao: string;
        flgAbstencao: number;
        representantesChapa: {}[];
      },
      opB: {
        idItemPauta: number;
        descricao: string;
        flgAbstencao: number;
        representantesChapa: {}[];
      }
    ) => {
      if (!opA.flgAbstencao && opB.flgAbstencao) return -1;
      if (opA.flgAbstencao && !opB.flgAbstencao) return 1;
      return 0;
    },
    []
  );

  return (
    <Row
      className={clsx([
        styles.root,
        getStatusClassName(
          Boolean(isEfetivacaoVoto)
            ? AssembleiaPautaStatus.Liberada
            : props.status
        ),
        props.pauta.votos && props.pauta.votos.length
          ? styles.tem_voto
          : styles.sem_voto,
        props.opened ? styles.opened : '',
      ])}
    >
      {props.pauta.tipoPauta === 1 || props.pauta.tipoPauta === 2 ? (
        <div
          className={clsx([
            styles.external,
            getStatusClassName(
              Boolean(isEfetivacaoVoto)
                ? AssembleiaPautaStatus.Liberada
                : props.status
            ),
          ])}
          onClick={() => {
            if (props.pauta.tipoPauta === 1) {
              openModalComissaoEleitoral();
            }
          }}
        >
          {props.pauta.tipoPauta === 1 ? (
            <div className={styles.tab}>
              <div className={styles.electionCommission}>
                <LegalPersonIcon />
                Comissão eleitoral
              </div>
            </div>
          ) : (
            <div className={styles.tab}>
              <div className={styles.agencyAndNucleou}>
                <div>
                  <AgencyIcon />
                  <span>
                    Agência <strong>{props.agency}</strong>
                  </span>
                </div>
                <div>
                  <ComunidadeIcon />
                  <span>
                    Núcleo <strong>{props.nucleou} </strong>
                  </span>
                </div>
              </div>
            </div>
          )}
        </div>
      ) : undefined}
      <div
        className={clsx([
          styles.inside,
          props.pauta.tipoPauta === 1 || props.pauta.tipoPauta === 2
            ? styles.removeLeftBorder
            : '',
          getStatusClassName(
            Boolean(isEfetivacaoVoto)
              ? AssembleiaPautaStatus.Liberada
              : props.status
          ),
          props.opened ? styles.opened : '',
        ])}
      >
        <div
          data-testid={`pauta-${props.pauta.idPauta}`}
          className={styles.header}
          onClick={handleToggle}
        >
          <div className={styles.firstLine}>
            <div className={styles.firstCol}>
              {!Boolean(isEfetivacaoVoto) ? (
                <div className={clsx([styles.timer, 'nunito'])}>
                  <CountdownTimer
                    counter={props.pauta.tempoRestante}
                    onCompleted={() =>
                      props.pauta.status === AssembleiaPautaStatus.Liberada
                        ? onCompletedContdown()
                        : undefined
                    }
                  />
                </div>
              ) : undefined}
              <div className={styles.etiqueta}>
                <span className={styles.icon}>{getStatusIcon()}</span>
                <span className={clsx([styles.label, 'nunito'])}>
                  {getStatusName(
                    Boolean(isEfetivacaoVoto)
                      ? AssembleiaPautaStatus.Liberada
                      : props.status
                  )}
                </span>
              </div>
            </div>
            <div
              className={clsx([styles.arrow, props.opened ? styles.cima : ''])}
            >
              <ChevronArrowDownIcon />
            </div>
          </div>
          <Row style={{ gap: '10px' }}>
            <Col className={styles.titleContainer} noPadding>
              {props.pauta.flgSecreta && isAssessorRoute && <BlockIcon />}
              {props.pauta.flgRestrita && isAssessorRoute && <RestritoIcon />}
              <div className={styles.titulo}>{props.titulo}</div>
            </Col>
            {props.hasAnexos ? (
              <Col noPadding>
                <Button
                  theme={ButtonThemes.Secondary}
                  leftIcon={<AnexoIcon />}
                  onClick={(e) => {
                    e.stopPropagation();
                    props.onClickAnexos && props.onClickAnexos();
                  }}
                  disabled={!props.hasAnexos}
                >
                  Anexos
                </Button>
              </Col>
            ) : (
              <Fragment />
            )}
          </Row>
        </div>
        <Collapse opened={Boolean(props.pauta.votos?.length && !props.opened)}>
          <div
            className={clsx([styles.voto_atual, 'nunito'])}
            onClick={handleToggle}
          >
            <RadioButton
              theme={RadioButtonType.New}
              value={true}
              disabled={
                opcoesDisabled ||
                props.pauta.estaVotadoPorOutroRepresentante ||
                !props.pauta.podeVotar
              }
            />
            {getItemPautaName(
              props.pauta.itens?.find((it: any) => it.idItemPauta === voto)
            )}
          </div>
        </Collapse>
        <Collapse opened={props.opened}>
          <div className={styles.corpo_pauta}>
            <div className={styles.descricao}>{props.descricao}</div>
            <div className={clsx([styles.opcoes_label, 'nunito'])}>
              Opções de voto:
            </div>
            <div className={styles.opcoes_de_voto}>
              {props.pauta.itens
                ?.sort(sortOptions)
                .map(
                  (
                    it:
                      | IAssembleiaAssociadoPautaOpcao
                      | IAssembleiasAssessorItens,
                    index: number
                  ) => {
                    return (
                      <div className={styles.opcao_de_voto}>
                        <button
                          key={index}
                          className={styles.radio_button}
                          onClick={() => setVotoAtual(it.idItemPauta)}
                          disabled={
                            Boolean(isEfetivacaoVoto)
                              ? false
                              : isAssessorRoute ||
                                (canVote !== undefined && !canVote) ||
                                (canVote && isAGO && permiteVoto)
                              ? true
                              : opcoesDisabled ||
                                (props.pauta.votos.length > 0 &&
                                  props.bloqAlteraVoto) ||
                                props.pauta.estaVotadoPorOutroRepresentante
                          }
                        >
                          <RadioButton
                            theme={RadioButtonType.New}
                            value={votoAtual === it.idItemPauta}
                            disabled={
                              Boolean(isEfetivacaoVoto)
                                ? false
                                : isAssessorRoute ||
                                  (canVote !== undefined && !canVote) ||
                                  (canVote && isAGO && permiteVoto)
                                ? true
                                : opcoesDisabled ||
                                  (props.pauta.votos.length > 0 &&
                                    props.bloqAlteraVoto) ||
                                  props.pauta.estaVotadoPorOutroRepresentante
                            }
                          />
                          <div
                            className={clsx([
                              votoAtual === it.idItemPauta ? styles.atual : '',
                              (canVote !== undefined && !canVote) ||
                              (canVote && isAGO && permiteVoto) ||
                              opcoesDisabled ||
                              (props.pauta.votos.length > 0 &&
                                props.bloqAlteraVoto)
                                ? styles.disabled
                                : '',
                            ])}
                          />
                          <span className={clsx([styles.nome, 'nunito'])}>
                            {getItemPautaName(it)}
                          </span>
                        </button>
                        {props.pauta.tipoPauta ===
                          AssembleiaTipoPauta.Eleicao &&
                          it.flgAbstencao === 0 && (
                            <div
                              className={styles.view_detail}
                              onClick={() => openModalDetalhesChapa(it)}
                            >
                              Ver detalhes
                            </div>
                          )}
                      </div>
                    );
                  }
                )}
              {props.pauta.votos.length > 0 &&
                props.pauta.status === AssembleiaPautaStatus.Liberada &&
                props.bloqAlteraVoto === false &&
                currentEvent!?.userCanVote! &&
                !props.pauta.estaVotadoPorOutroRepresentante && (
                  <p className={'nunito'} style={{ margin: '1rem 0px' }}>
                    Se desejar alterar seu voto, selecione uma opção diferente e
                    clique no botão: Alterar voto.
                  </p>
                )}
            </div>
            <div className={styles.actions_line}>
              {props.pauta.itens.length > 0 ? (
                <AssembleiaPautaAssociadoActionButtons
                  loading={loading}
                  setLoading={setLoading}
                  pauta={{
                    ...(props.pauta as IAssembleiaAssociadoPauta),
                    status: Boolean(isEfetivacaoVoto)
                      ? AssembleiaPautaStatus.Liberada
                      : props.pauta.status,
                  }}
                  voto={votoAtual!}
                  onVotoError={onVotoError}
                  onVotoSuccess={(voto: any) => {
                    handleVotoSuccess(voto);
                    setMostrarVotoEnviado(true);
                    timeoutFecharSucesso = setTimeout(() => {
                      setMostrarVotoEnviado(false);
                      props.toggleOpened(false);
                    }, 2000);
                  }}
                  isEfetivacaoVoto={Boolean(isEfetivacaoVoto)}
                  canParticipate={props.canParticipate || false}
                  cpfEfetivacaoPresencial={props.cpfEfetivacaoPresencial}
                  updateVotoPresencial={props.updateVotoPresencial}
                  canSeeResults={props.canSeeResults}
                />
              ) : undefined}
            </div>
          </div>
        </Collapse>
        {[AssembleiaStatus.Live, AssembleiaStatus.Pre].includes(
          currentEvent!?.status!
        ) ||
        (Boolean(isEfetivacaoVoto)
          ? AssembleiaPautaStatus.Liberada
          : props.status !== STATUS_PAUTA_ENCERRADA ||
            !props.pauta.votos.length) ? (
          <Collapse opened={!props.opened}>
            <div className={styles.bottom_bar} onClick={handleToggle}>
              <span className={styles.icon}>{getBarLabel!?.icon}</span>
              <span className={clsx([styles.label, 'nunito'])}>
                {getBarLabel!?.label}
              </span>
            </div>
          </Collapse>
        ) : undefined}
        <CSSTransition
          in={mostrarVotoEnviado}
          timeout={500}
          classNames={'fade'}
          mountOnEnter
          unmountOnExit
        >
          <div className={styles.voto_enviado}>
            <IconButton
              icon={<CloseIcon />}
              className={styles.close_icon}
              onClick={() => {
                setMostrarVotoEnviado(false);
                props.toggleOpened(false);
                if (timeoutFecharSucesso) clearTimeout(timeoutFecharSucesso);
              }}
            />
            <div className={styles.icon}>
              <CheckCircleIcon />
            </div>
            <div className={styles.label}>Voto enviado!</div>
          </div>
        </CSSTransition>
      </div>
    </Row>
  );
}

export default memo(AssembleiaPautaNew);
